module.exports = __webpack_public_path__ + "static/media/1POLICY37.2248fd32.jpg";